export default "__VITE_ASSET__863b4e82__"